<div  style="background: black;
  width: 550px; 
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 8%;
  right: 30%;
  z-index: 1000;
  cursor: grab;" cdkDrag cdkDragHandle >  
   
      <div style="display: flex;justify-content: space-between;">
          <span  style="color: white; font-size: 13px;display: flex; align-items: center;">You're currently viewing as {{viewRole}}</span>
        <!-- <div>
            <mat-form-field>
                <mat-label>Country</mat-label>
                <mat-select
                  name="dropCategory"
                  [value]=""
                  #country
                
                  required
                >
                  <mat-option
                    
                    ></mat-option
                  >
                </mat-select>
              </mat-form-field>
        </div> -->
        <div>
            <!-- <button style="background-color:#FFBC0F;color: #57461B; border: none; border-radius: 4px;font-size: 13px;margin-right: 6px;" >Update</button> -->
            <button style="background-color: #D14040;color: white; border: none; border-radius: 4px;font-size: 13px;padding: 4px 8px 4px 8px;width: 48px;" (click)="onExit()" >Exit</button>
        </div>
        
      </div>
      
    </div>
    <app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
    
